import { Box, useTheme } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import Heading, { HeadingSize, headingCID } from '../Heading';

import ContainerFloat from './ContainerFloat';

export interface ContainerHeaderProps {
  /** The float content floats to the right */
  float?: React.ReactNode;
  title: string;
}

const HEADER_GAP = 4;

/**
 * Holds a header and menu items that float to the top right of the container
 */
const ContainerHeader: FC<PropsWithChildren<ContainerHeaderProps>> = ({ children, float, title }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        [`& .${headingCID}`]: {
          marginBottom: 0,
        },
        alignItems: { xs: 'start', md: 'center' },
        display: 'flex',
        marginBottom: '1rem',
        marginTop: '1rem',
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flex: 1,
          gap: theme.spacing(HEADER_GAP),
          paddingBottom: '5px',
          paddingTop: '5px',
        }}
      >
        <Heading size={HeadingSize.LG}>{title}</Heading>
        {children}
      </Box>
      {float && <ContainerFloat>{float}</ContainerFloat>}
    </Box>
  );
};

export default ContainerHeader;
